import React from "react";

function LoaderComponent({ isLoading }) {
  return isLoading ? (
    <div className="loader">
      <span>
        <img src="/assets/svg/loaderImage.svg" alt="Loader_Image" />
      </span>
    </div>
  ) : null;
}

export { LoaderComponent };
